// typescript
import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {CdkStepper, CdkStepperNext, CdkStepperPrevious} from "@angular/cdk/stepper";
import {faChevronLeft, faChevronRight} from "@fortawesome/pro-solid-svg-icons";
import {NgClass} from '@angular/common';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {TooltipDirective} from "@buildinginformationcloud/bic-ui-components";

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  providers: [{provide: CdkStepper, useExisting: StepperComponent}],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, CdkStepperPrevious, FaIconComponent, CdkStepperNext, TooltipDirective]
})
export class StepperComponent extends CdkStepper {

  @Input() isCheckView: boolean = false;
  @Input() nextStepAllowed : boolean = false;
  @Input() previousStepAllowed : boolean = false;
  @Input() stepTooltips: (string | undefined)[] = [];
  @Output() currentIndexChange = new EventEmitter<number>();

  @Input()
  set currentIndex(value: number | null) {
    if (typeof value === 'number' && value !== super.selectedIndex) {
      super.selectedIndex = value;
    }
  }


  get selectedIndex(): number {
    return super.selectedIndex;
  }

  set selectedIndex(value: number) {
    super.selectedIndex = value;
    this.currentIndexChange.emit(value);
  }

  isStepEnabled(index: number): boolean {
    return this.steps.get(index)?.editable !== false;
  }

  onClick(index: number): void {
    if (
      this.isStepEnabled(index) &&
      (
        (this.nextStepAllowed && index > this.selectedIndex && (!this.linear || index === this.selectedIndex + 1)) ||
        (this.previousStepAllowed && index < this.selectedIndex && (!this.linear || index === this.selectedIndex - 1))
      )
    ) {
      this.selectedIndex = index;
      this.currentIndexChange.emit(index);
    }
  }

  protected readonly faLinkIcon = faChevronRight;
  protected readonly faChevronLeft = faChevronLeft;
  protected readonly faChevronRight = faChevronRight;
  protected readonly Array = Array;
}
